export default __webpack_public_path__ + "static/media/funding.32cb0922.svg";